// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainPage from "./pages/mainPage";
import Register from "./components/register";
import Dashboard from "./pages/dashboard";
import LoginPage from "./pages/loginPage";
import AddStudent from "./pages/addstudents";
import Course from "./pages/coursePage";
import Confirmation from "./pages/confirmation";
import BlogPage from "./pages/blogs";
import CoursePages from "./pages/coursepages";
import EnrollPage from "./pages/enrol";
import NavBar from "./components/navbar"; // Import NavBar
import Blog from "./pages/blog"; // Import NavBar
import Contact from "./pages/contact";
import { ProtectedRoute } from "./config/privateRoutes";
import { useAuth } from "./config/AuthContext"; // Import the custom hook
import Faq from "./pages/faq";
function App() {
  const { user, isFetching } = useAuth(); // Get user and isFetching from context

  if (isFetching) {
    return <div>Loading...</div>; // Optional loading state
  }

  return (
    <div>
      <BrowserRouter>
        {/* Pass user state to NavBar */}
        <NavBar user={user} />
        <Routes>
          <Route index element={<MainPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/courses" element={<Course />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Blogs/:blogid" element={<BlogPage />} />
          <Route path="/courses/:courseid" element={<CoursePages />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute user={user}>
                <Dashboard user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/addstudent"
            element={
              <ProtectedRoute user={user}>
                <AddStudent user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/:courseid/enroll"
            element={
              <ProtectedRoute user={user}>
                <EnrollPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/:courseid/confirmation"
            element={
              <ProtectedRoute user={user}>
                <Confirmation />
              </ProtectedRoute>
            }
          />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
